import Christmas from "@assets/svg/GUIDScreens/Christmas";
import FathersDay from "@assets/svg/GUIDScreens/FathersDay";
import MothersDay from "@assets/svg/GUIDScreens/MothersDay";
import Party from "@assets/svg/GUIDScreens/Party";
import Valentine from "@assets/svg/GUIDScreens/Valentine";
import Techy from "@assets/svg/GUIDScreens/Techy";
import ChristmasThumbnail from "@assets/svg/GUIDThumbnails/ChristmasThumbnail";
import FathersDayThumbnail from "@assets/svg/GUIDThumbnails/FathersDayThumbnail";
import MothersDayThumbnail from "@assets/svg/GUIDThumbnails/MothersDayThumbnail";
import PartyThumbnail from "@assets/svg/GUIDThumbnails/PartyThumbnail";
import ValentineThumbnail from "@assets/svg/GUIDThumbnails/ValentineThumbnail";
import TechyThumbnail from "@assets/svg/GUIDThumbnails/TechyThumbnail";
import type { GUIDScreenProps } from "@assets/svg/GUIDScreens/types";
import type { ComponentType } from "react";

export enum GUIDType {
  Party = "Party",
  Christmas = "Christmas",
  MothersDay = "MothersDay",
  FathersDay = "FathersDay",
  Valentine = "Valentine",
  Techy = "Techy",
}

type GuidVariantProps = {
  guidType: GUIDType;
};

const GUID_COMPONENTS: Record<GUIDType, ComponentType<GUIDScreenProps>> = {
  [GUIDType.Christmas]: Christmas,
  [GUIDType.FathersDay]: FathersDay,
  [GUIDType.MothersDay]: MothersDay,
  [GUIDType.Party]: Party,
  [GUIDType.Valentine]: Valentine,
  [GUIDType.Techy]: Techy,
};

export const Background: React.FC<GuidVariantProps & GUIDScreenProps> = ({
  guidType,
  line1,
  line2,
}) => {
  const Component = GUID_COMPONENTS[guidType];
  return <Component line1={line1} line2={line2} />;
};

export const Thumbnail: React.FC<GuidVariantProps> = ({ guidType }) => {
  switch (guidType) {
    case GUIDType.Christmas:
      return <ChristmasThumbnail />;
    case GUIDType.FathersDay:
      return <FathersDayThumbnail />;
    case GUIDType.MothersDay:
      return <MothersDayThumbnail />;
    case GUIDType.Party:
      return <PartyThumbnail />;
    case GUIDType.Valentine:
      return <ValentineThumbnail />;
    case GUIDType.Techy:
      return <TechyThumbnail />;
    default:
      return null;
  }
};
